// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2HsOE","signatureButtonsRight":"ModalSign_signatureButtonsRight__3TWpK"};